import React from "react";
import "./style.scss";
import { Link } from "gatsby";

import Navbar from "../navbar";
import Footer from "../footer";
export default function FeatureCategory({
  categoryName = "Feature Category",
  products = [],
  categoryDescription = "",
}) {
  return (
    <div className="feature-category">
      <Navbar />
      <div className="feature-category__content">
        <h1 className="heading-primary">{categoryName}</h1>

        <p
          className="feature-category__des"
          dangerouslySetInnerHTML={{ __html: categoryDescription }}
        />

        <div className="feature-category__container">
          <div className="row">
            {products.map((product, i) => (
              <div className="col col-12  col-md-6 col-lg-4">
                <Link to={product.link}>
                  <div className="feature-category__product">
                    <img
                      alt="Feature Product"
                      className="feature-category__product__img"
                      src={product.img}
                    />
                    <div className="feature-category__product__name">
                      {product.name}
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
